import { CHECK_MARGIN_DATA, CHECK_MARGIN_ERROR_DATA, CHECK_MARGIN_HIDE_ERROR_DATA, CHECK_MARGIN_START_LOADER, CHECK_MARGIN_STOP_LOADER, REMOVE_MARGIN_DATA, } from "../interface/ICheckMargin";
const initState = {
    data: {
        orderMargin: "",
        availableCash: "",
        marginUsed: "",
        insufficientFund: "",
        emsg: "",
        status: "",
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const checkMargin = (state = initState, action) => {
    switch (action.type) {
        case CHECK_MARGIN_DATA: {
            return Object.assign(Object.assign({}, state), { data: action.payload.checkMargin });
        }
        case REMOVE_MARGIN_DATA: {
            return Object.assign(Object.assign({}, state), { data: initState.data });
        }
        case CHECK_MARGIN_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case CHECK_MARGIN_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case CHECK_MARGIN_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case CHECK_MARGIN_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default checkMargin;
